// Misc
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'

// Constants
import { INTEGRATION_STRIPE_CONNECTED } from 'constants/redirectEvents'

// Utils
import { RegisterEventRedirectOnClick } from 'utils/eventRedirect'

// Selectors
import { connectGetters } from 'react-redux-getters'
import { getCurrencyData } from 'selectors/me'
import { isStripeConnected } from 'selectors/integrations'

// Atoms
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Checkbox from '@material-ui/core/Checkbox'
import Typography from '@material-ui/core/Typography'
import Spacer from 'atoms/Spacer'
import NumberInput from 'atoms/NumberInput'
import Warning from 'atoms/Warning'
import { StyledLink } from 'atoms/Link'
import FieldLayout from '../FieldLayout'

const mapGettersToProps = state => ({
  currencyDataGetter: getCurrencyData(state),
  isStripeConnectedGetter: isStripeConnected(state),
})

export default
@connectGetters(mapGettersToProps)
class ProposalPriceEditor extends Component {
  static propTypes = {
    proposal: PropTypes.object.isRequired,
    currencyDataGetter: PropTypes.object.isRequired,
    isStripeConnectedGetter: PropTypes.object.isRequired,
    onProposalUpdate: PropTypes.func.isRequired,
    onDelete: PropTypes.func.isRequired,
  }

  handleAmountSave = (price) => {
    const { onProposalUpdate } = this.props
    onProposalUpdate({ price: price * 100 })
  }

  handlePaymentChange = (ev) => {
    const { onProposalUpdate } = this.props
    const { checked } = ev.target
    onProposalUpdate({ invoiceCreate: checked })
  }

  handleDelete = () => {
    const { onDelete } = this.props
    onDelete({
      price: null,
      invoiceCreate: false,
    })
  }

  render() {
    const { proposal, currencyDataGetter, isStripeConnectedGetter } = this.props
    const { price, invoiceCreate } = proposal
    const currencyData = currencyDataGetter.data || {}
    const currency = currencyData.symbol || ''
    const defaultValue = parseInt(price, 10) / 100
    return (
      <Fragment>
        <Spacer />
        <FieldLayout title="Price" onDelete={this.handleDelete}>
          <NumberInput
            required
            minValue={0}
            placeholder="Enter price..."
            leftHelper={!!currency && (
              <Typography variant="caption" color="textSecondary">
                { currency }
              </Typography>
            )}
            defaultValue={defaultValue}
            onSave={this.handleAmountSave}
          />
          <FormControlLabel
            control={(
              <Checkbox
                disabled={!isStripeConnectedGetter.data}
                checked={!!invoiceCreate}
                onChange={this.handlePaymentChange}
              />
            )}
            label="Request payment"
          />
          { !isStripeConnectedGetter.data && (
            <Warning>
              Connect Stripe account
              {' '}
              <RegisterEventRedirectOnClick
                event={INTEGRATION_STRIPE_CONNECTED}
                component={StyledLink}
                to="/integrations"
              >
                here
              </RegisterEventRedirectOnClick>
              {' '}
              to enable payments
            </Warning>
          ) }
        </FieldLayout>
      </Fragment>
    )
  }
}
